export default __webpack_public_path__ + "static/media/arrow-down.e128e375.svg";